import { useFirestoreQueryData } from "@react-query-firebase/firestore";
import { User } from "../models";
import { useCache } from "../context/CacheContext";
import { queryKeys } from "../data/queryKeys";

const useUsers = () => {
  const { cacheKey } = useCache();
  return useFirestoreQueryData(queryKeys.users(cacheKey), User.list(), {
    subscribe: false,
  });
};

export const useAllUsers = () => {
  const { cacheKey } = useCache();
  return useFirestoreQueryData(queryKeys.allUsers(cacheKey), User.listAll(), {
    subscribe: false,
  });
};

export default useUsers;
